import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.44.438A1.503 1.503 0 0 1 2.422.315l.141.125 10.498 10.493c.54.54.582 1.387.126 1.975l-.125.14L2.564 23.56a1.503 1.503 0 0 1-2.123.003 1.496 1.496 0 0 1-.128-1.977l.125-.141 9.44-9.454-9.44-9.435A1.496 1.496 0 0 1 .316.58L.44.438Z",
      fill: "#fff"
    }, null, -1)
  ]))]))
}